"use client"

import { Toaster as Sonner } from "sonner"

const Toaster = (props: React.ComponentProps<typeof Sonner>) => (
  <Sonner
    position="top-right"
    gap={8}
    toastOptions={{
      unstyled: true,
      classNames: {
        toast: "w-full",
      },
    }}
    style={{ "--width": "360px" } as React.CSSProperties}
    {...props}
  />
)

export { Toaster }
